<template>
  <layout-auth>
    <p class="text-center">Redirecting...</p>
  </layout-auth>
</template>

<script>
import auth from "../../api/auth";
import {ENUMS} from "../../services/enums";
import LocalStorage from "../../services/localStorage";
import dates from "../../services/dates";
import axios from "axios";
import router from "../../router";
import api from "../../api";
import {SnackbarProgrammatic as Snackbar} from 'buefy';

export default {
  name: "ThirdPartyLogin",
  metaInfo: {
    title: "Redirect"
  },
  mounted() {
    const token = this.$route.query.token;
    auth.loginViaToken(token).then(() => {
      router.push('/');
    })
  }
};
</script>

<style lang="scss" scoped>

</style>
